"use client"

import { toast as sonnerToast } from "sonner"

/**
 * Bridge between Radix Toast and Sonner
 */
function toast(props) {
  const { title, description, variant, action, duration, id: passedId, ...otherProps } = props;
  
  const options = {
    description,
    duration: duration || 5000,
    id: passedId,
    ...otherProps
  }

  if (action && typeof action === 'object') {
    options.action = {
      label: action.props?.altText || action.props?.children || "Action",
      onClick: action.props?.onClick || (() => {})
    }
  }

  let toastId;
  const message = title || description || "";

  if (variant === "destructive") {
    toastId = sonnerToast.error(message, options);
  } else if (variant === "success") {
    toastId = sonnerToast.success(message, options);
  } else {
    toastId = sonnerToast(message, options);
  }

  return {
    id: toastId,
    dismiss: () => sonnerToast.dismiss(toastId),
    update: (newProps) => toast({ ...props, ...newProps, id: toastId })
  }
}

function useToast() {
  return {
    toast,
    dismiss: (id) => sonnerToast.dismiss(id),
    update: (props) => toast(props), // Basic polyfill if needed
  }
}

export { useToast, toast }
